export const supportedOrderedDatabases = [
    "mysql",
    "postgres",
    "mongodb",
    "dynamodb",
    "cassandra",
    "oracledb",
    "mssql",
    "redis",
    "elasticsearch",
    "ibmdb2"
]

export const supportedDatabasesTitles = {
    mysql: "MySQL",
    postgres: "PostgreSQL",
    mongodb: "MongoDB",
    dynamodb: "DynamoDB",
    cassandra: "Cassandra",
    oracledb: "OracleDB",
    mssql: "SQL Server",
    redis: "Redis",
    elasticsearch: "Elasticsearch",
    ibmdb2: "IBM DB2"
  }